import { render, staticRenderFns } from "./CampusEditarForm.vue?vue&type=template&id=30d881c4"
import script from "./CampusEditarForm.vue?vue&type=script&lang=js"
export * from "./CampusEditarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports